// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2kfB1","col":"styles_col__ChOQB","fulfillmentStatus":"styles_fulfillmentStatus__R0wbs","emailCol":"styles_emailCol__1d7ZL"};